import {
  Badge,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Dialog,
  Checkbox,
  FormControlLabel,
  DialogContent,
  DialogTitle,
  DialogActions
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { fetchAgentTrackData, getAgentVisitSnippet } from "../../api";
import { toast } from "react-toastify";
import { f } from "../../utility/Formater";
import CustomTableV2 from "../../Components/CustomTable/CustomTableV2";
import AgentVisitDialog from "../../Components/Dialogs/AgentVisitsModal";
import MapIcon from "@mui/icons-material/Map";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import MyLocationOutlinedIcon from "@mui/icons-material/MyLocationOutlined";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useNavigate } from "react-router";
import SetTargetModal from "../../Components/Dialogs/SetTarget";
import AddIcon from "@mui/icons-material/Add";
import MapView from "../../Components/Dialogs/MapView";
import ViewTargetModal from "../../Components/Dialogs/ViewTarget";
import { GlobalContext } from "../../Context/GlobalContext";
import ViewAgentFilesStatus from "../../Components/Dialogs/ViewAgentFilesStatus";
import AgentTrackerExports from "../../Components/Dialogs/AgentTrackerExports";
import { UserContext } from "../../Context/UserContext";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";



function AgentTrackerTable() {
  const { agentsCurrentMonthTargetPercentageState } = useContext(GlobalContext);
  const { user } = useContext(UserContext);
  const [
    agentsCurrentMonthTargetPercentage,
    setAgentsCurrentMonthTargetPercentage,
  ] = agentsCurrentMonthTargetPercentageState;
  const [tableData, setTableData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const [filter, setFilter] = useState(
    localStorage.getItem("agentTrackerFilter") || "live_till_date"
  );
  const navigate = useNavigate();
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [isPageLoading, setPageLoading] = useState(false);

  const [visitData, setVisitData] = useState({});
  const [cashToBeCollected, setCashToBeCollected] = useState(0);
  const [agentTarget, setAgentTarget] = useState({
    open: false,
    agents: [],
  });
  const [openMapView, setOpenMapView] = useState(false);
  const [viewTarget, setViewTarget] = useState({
    open: false,
    agentCode: "",
  });
  const [agentFilesStatusPopup, setAgentFilesStatusPopup] = useState({
    open: false,
    agentDetails: null
  });
  const [exportDialog, setExportDialog] = useState(false);
  const [city, setCity] = useState("");
  const [editCity, setEditCity] = useState(false);
  const [name, setName] = useState("");
  const [editName, setEditName] = useState(false);
  const [ascName, setAscName] = useState(true);
  const [ascCity, setAscCity] = useState(true);
  const [ascVisit, setAscVisit] = useState(true);
  const [sortKey, setSortKey] = useState("");
  const [ascDistance, setAscDistance] = useState(true);
  const [ascLoginCount, setAscLoginCount] = useState(true);
  const [ascDisbursal, setAscDisbursal] = useState(true);
  const [distanceByAgent, setDistanceByAgent] = useState("");
  const [agentTrackerMessageOpen, setAgentTrackerMessageOpen] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [textValue, setTextValue] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  function handlePageChange(page) {
    setPage(page);
    fetchTableData(
      page,
      limit,
      "filter",
      localStorage.getItem("agentTrackerFilter") || "live_till_date",
      null,
      true
    );
  }

  const fetchSortedData = (key, order) => {
    const sortValue = `${key}_${order}`;
    setSortKey(sortValue);
    fetchTableData(page, limit, "filter", filter, null, false, city, name, sortValue);
  };

  const handleSortClick = (key, order) => {
    if(key == "city") {
      setAscName(true);
      setAscVisit(true);
      setAscDistance(true);
      setAscDisbursal(true);
      setAscLoginCount(true);
    } else if(key == "name") {
      setAscCity(true);
      setAscVisit(true);
      setAscDistance(true);
      setAscDisbursal(true);
      setAscLoginCount(true);
    } else if(key == "visit") {
      setAscName(true);
      setAscCity(true);
      setAscDistance(true);
      setAscDisbursal(true);
      setAscLoginCount(true);
    } else if(key == "distance") {
      setAscName(true);
      setAscCity(true);
      setAscVisit(true);
      setAscDisbursal(true);
      setAscLoginCount(true);
    } else if(key == "login") {
      setAscName(true);
      setAscCity(true);
      setAscVisit(true);
      setAscDistance(true);
      setAscDisbursal(true);
    } else if(key == "disbursal") {
      setAscName(true);
      setAscCity(true);
      setAscVisit(true);
      setAscDistance(true);
      setAscLoginCount(true);
    }
    let newOrder;
    if(order == "asc") {
      newOrder = "desc"
    } else {
      newOrder = "asc"
    }
    fetchSortedData(key, newOrder);
    }
  

  let columns = [
    {
      label: "View Targets",
      render: (i) => {
        return (
          <Button
            variant="contained"
            onClick={() => {
              setViewTarget({
                ...viewTarget,
                open: true,
                agentCode: tableData?.[i]?.agent_code,
                name: tableData?.[i]?.name,
                department: tableData?.[i]?.department,
              });
            }}
            // size="medium"
            sx={{
              background: "linear-gradient(90deg, #801AE6 0%, #A21AE6 100%)",
              borderRadius: 27,
              width: "100px",
            }}
            disableElevation
            startIcon={<MyLocationOutlinedIcon fontSize="small" />}
          >
            {agentsCurrentMonthTargetPercentage?.[tableData?.[i]?.agent_code]
              ? `${
                  agentsCurrentMonthTargetPercentage?.[
                    tableData?.[i]?.agent_code
                  ]
                }%`
              : "View"}
          </Button>
        );
      },
    },
    {
    label: (
        <div style={{ display: "flex", alignItems: "center", width: editCity ? 200 : 120 }}>
          {editCity ? (
            <>
              <TextField
                autoFocus
                variant="outlined"
                size="small"
                label="City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchSearchTableData();
                  }
                }}
                sx={{ width: "100%" }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      size="small"
                      onClick={() => {
                        if (city === "") {
                          setEditCity(false);
                        } else {
                          setCity("");
                          setEditCity(false);
                          fetchTableData(page, limit, "filter", filter, null, false, "", name);
                        }
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  ),
                }}
              />
            </>
          ) : (
            <>
              <div style={{cursor: "pointer"}}>
              </div>
                <span 
                  onClick={() => {
                    setAscCity((prev) => !prev)
                    handleSortClick("city", ascCity ? "asc" : "desc")
                    }}
                  style={{cursor:"pointer"}}  
                  >
                  City 
                </span>
                <IconButton 
                  size="small"
                  sx={{marginLeft: 2}}
                >
                  <SearchIcon
                  fontSize="small"
                  onClick={() => setEditCity(true)}
                  />
                </IconButton>
            </>
          )}
        </div>
      ),
      render: (i) => {
        return f(tableData[i]?.city);
      },
      width: 500,
    },
    {
      label: (<div style={{ display: "flex", alignItems: "center", width: 80 }}>
        <span
         onClick={() => { 
          setAscVisit((prev) => !prev)
          handleSortClick("visit_count", ascVisit ? "asc" : "desc")
          }}
        style={{cursor:"pointer"}}
        >
          Visits
        </span>
      </div>),
      render: (i) => {
        const isDisabled = !Boolean(tableData[i]?.visitsData);
        return (
          <span className="d-flex flex-row">
            <IconButton
              size="small"
              color="secondary"
              className="me-2"
              disabled={isDisabled}
              onClick={() => {
                setVisitData({
                  open: true,
                  agentData: tableData[i] || {},
                });
              }}
            >
              <Badge
                badgeContent={
                  isDisabled ? 0 : tableData[i]?.visitsData?.visit_count || 0
                }
                color="info"
                max={9999}
              >
                <MapIcon fontSize="small" />
              </Badge>
            </IconButton>
          </span>
        );
      },
      width: 500,
    },
    {
      label: (<div style={{ display: "flex", alignItems: "center", width: editName ? 200 : 120 }}>
        {editName ? (
          <>
            <TextField
              autoFocus
              variant="outlined"
              size="small"
              label="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchSearchTableData();
                }
              }}
              sx={{ width: "100%" }}
              InputProps={{
                endAdornment: (
                  <IconButton size="small" onClick={() => {
                    if (name === "") {
                      setEditName(false)
                    } else {
                      setName("");
                      setEditName(false);
                      fetchTableData(page, limit, "filter", filter, null, false, city, "");
                    }
                  }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </>
        ) : (
          <>
              <span
                onClick={() => { 
                  setAscName((prev) => !prev)
                  handleSortClick("name", ascName ? "asc" : "desc")
                  }}
                style={{cursor: "pointer"}}
              >
                Name 
              </span>
              <IconButton 
                size="small"
                sx={{marginLeft: 2}}
                >
                  <SearchIcon 
                    fontSize="small"
                    onClick={() => setEditName(true)}
                    />
              </IconButton>
          </>
        )}
      </div>),
      render: (i) => {
        return (
          <span className="d-flex flex-row">
            {f(tableData[i]?.name)}
          </span>
        );
      },
      width: 400,
    },
    filter !== "today" && {
      label: (
        <span className="w-100 d-flex flex-column lh-1"
              onClick={()=> {
              setAscDistance((prev) => !prev)
              handleSortClick("distance", ascDistance ? "asc" : "desc" )}}
              style={{cursor: "pointer"}}>
          <span 
            className="text-nowrap"
          >
              Distance Traveled
          </span>
          <br />
          <span className="w-100 text-center" style={{ fontSize: 12 }}>
            (In km)
          </span>
        </span>
      ),
      render: (i) => {
        const distance = (
          (tableData[i]?.total_traveled_distance || 0) / 1000
        ).toFixed(2);
        return f(Number(distance)?.toLocaleString("en-IN"));
      },
    },
    {
      label: "Mobile No.",
      render: (i) => {
        return f(tableData[i]?.mobile_number);
      },
    },
    {
      label: "Dealers",
      render: (i) => {
        return (
          <div
            className="pointer"
            style={{
              padding: "5px 10px",
            }}
            onClick={() => {
              navigate(`/update-agent/${tableData[i]?.agent_code}`, {
                state: {
                  path: "/agent-tracker",
                  scroll: "dealer",
                },
              });
            }}
          >
            {(tableData[i]?.anchorCount || 0) + " Dealers"}
          </div>
        );
      },
      value: "anchorCount",
      width: 130,
    },
    {
      label: <span className="text-nowrap"
      onClick={()=> {
        setAscLoginCount((prev) => !prev)
        handleSortClick("login", ascLoginCount ? "asc" : "desc" )}}
      style={{cursor: "pointer"}}
      >
        Files-Logged In</span>,
      render: (i) => {
        return filter === "today" ? (
          tableData[i]?.logged_in_file || 0
        ) : (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setAgentFilesStatusPopup({
                open: true,
                agentDetails: tableData[i]
              });
            }}
          >
            <div>
              {tableData[i]?.logged_in_file || 0} /{" "}
              {tableData[i]?.agentTargetData?.total_login || 0}
            </div>
          </Button>
        );
      },
      value: "amount",
      width: 130,
    },
    {
      label: <span
      onClick={()=> {
        setAscDisbursal((prev) => !prev)
        handleSortClick("disbursal", ascDisbursal ? "asc" : "desc" )}}
        style={{cursor: "pointer"}}
      >
        Disbursed
        </span>,
      render: (i) => {
        return filter === "today" ? (
          tableData[i]?.disbursed_files || 0
        ) : (
          <div>
            {tableData[i]?.disbursed_files || 0} /{" "}
            {tableData[i]?.agentTargetData?.total_disbursement || 0}
          </div>
        );
      },
      value: "disbursed_files",
      width: 130,
    },
    {
      label: "Departments",
      render: (i) => {
        if (
          tableData[i]?.department &&
          Array?.isArray(tableData[i]?.department)
        ) {
          return tableData[i]?.department?.map((item) => {
            return <span className="agent-dep-chip">{item}</span>;
          });
        } else {
          return f(null);
        }
      },
      value: "department",
      width: 130,
    },
    {
      label: <span className="text-nowrap">Cash receipt Amt</span>,
      render: (i) => {
        let cash = tableData[i]?.cash_receipt_amount;
        return (
          <span
            className={cash ? "pointer" : ""}
            onClick={() => {
              navigate(`/cash-receipt-data`, {
                state: {
                  filter: "agent_name",
                  data: tableData[i],
                  date: filter,
                },
              });
            }}
          >
            {f(cash, "cur")}
          </span>
        );
      },
      value: "cash_receipt_amount",
      width: 130,
    },
    {
      label: <span className="text-nowrap">Money collected</span>,
      render: (i) => {
        return f(tableData[i]?.money_collected, "cur");
      },
      value: "money_collected",
      width: 120,
    },
    {
      label: <span className="text-nowrap">GPS Installed</span>,
      render: (i) => {
        return tableData[i]?.gps_count || 0;
      },
      value: "gps_count",
      width: 120,
    },
  ].filter(Boolean);


  const fetchTableData = async (
    page,
    limit,
    type,
    typeValue,
    search,
    pageChange,
    city,
    name,
    sortValue,
  ) => {
    let filter_data = typeValue || localStorage.getItem("agentTrackerFilter");
    if (pageChange) setPageLoading(true);
    else setLoading(true);

    try {
      let params = `/${filter_data}?page=${page}&limit=${limit}`;
      if (typeof city === "string" && city.trim()) params += `&city=${encodeURIComponent(city)}`;
      if (typeof name === "string" && name.trim()) params += `&name=${encodeURIComponent(name)}`;
      if (sortValue) {
        params += `&sort=${encodeURIComponent(sortValue)}`;
      }
      let { data } = await fetchAgentTrackData(params);
      if(user?.isUserPresenter){
        let city = ""
        data["data"] = data?.data?.filter(itm=>{
          if(city === itm?.city){
            return false;
          }
          city = itm?.city;
          return true;
        }) || []
      }
      setTableData(data?.data || []);
      setCount(data?.total_count);
      const moneyToBeClctd = data?.data?.reduce((acc, rowData) => {
        const cash_receipt_amount = rowData?.cash_receipt_amount || 0;
        const money_collected = rowData?.money_collected || 0;
        return acc + (cash_receipt_amount - money_collected);
      }, 0);
      setCashToBeCollected(moneyToBeClctd);
    } catch (error) {
      toast?.error(error?.response?.data?.message);
    }
    if (pageChange) setPageLoading(false);
    else setLoading(false);
  };

  const fetchSearchTableData = () => {
    fetchTableData(page, limit, "filter", filter, null, false, city, name);
  }

  const IntialDataFetch = () => {
    let initialFilter =
      localStorage.getItem("agentTrackerFilter") || "live_till_date";
    fetchTableData(page ?? 1, 50, "filter", initialFilter);
  };

  const handleChange = (event) => {
    localStorage.setItem("agentTrackerFilter", event.target.value);
    setFilter(event.target.value);
    setPage(1);
    fetchTableData(1, 50, "filter", event.target.value, null, false, city, name);
  };

  const handleTextChangeFyno = (event) => {
    const input = event.target.value;
    
    // Allow only numbers and limit to 10 characters
    if (/^\d*$/.test(input) && input.length <= 10) {
      setTextValue(input);
    }
  };

  const handleChangeFyno = (event) => {
    const { name, value, checked } = event.target;

    setSelectedValues((prev) => {
      if (checked) {
        return [...prev, value]; // Add value if checked
      } else {
        return prev.filter((item) => item !== value); // Remove value if unchecked
      }
    });
  };

  const downloadExcel = async () => {
    try {
      const finalContacts = addNew && textValue.trim() ? [...selectedValues, textValue.trim()] 
      : selectedValues;
      const payload = { contacts: finalContacts };

      console.log("Payload to send:", payload); // Debugging

      const response = await getAgentVisitSnippet(payload, selectedDate);
      const base64Data = response.data.base64Data;
      if (!base64Data) {
        throw new Error("No file data received from the server");
      }

      const binaryData = atob(base64Data);
      const arrayBuffer = new Uint8Array(binaryData.length).map((_, i) => binaryData.charCodeAt(i));
      const fileBlob = new Blob([arrayBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      const downloadLink = document.createElement("a");
      const fileURL = URL.createObjectURL(fileBlob);
      downloadLink.href = fileURL;
      downloadLink.download = "Agent-visit.xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      setAgentTrackerMessageOpen(false);
      setTextValue("");
      setAddNew(false);
    }
  };

  useEffect(() => {
    IntialDataFetch();
  }, []);

  return (
    <>
      <div className="px-3">
        <div className="d-flex flex-row justify-content-between py-3">
          <div className="d-flex flex-row align-items-center">
            <div
              style={{
                fontSize: 18,
                fontWeight: 600,
                marginRight: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              Agent Tracker
            </div>
            <div
              style={{
                width: 200,
              }}
            >
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Date</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filter}
                  label="Date"
                  onChange={handleChange}
                >
                  <MenuItem value={"today"}>Today</MenuItem>
                  <MenuItem value={"current_month"}>Current Month</MenuItem>
                  <MenuItem value={"last_seven_days"}>Last 7 days</MenuItem>
                  <MenuItem value={"last_month"}>Last Month</MenuItem>
                  <MenuItem value={"live_till_date"}>Live Till Date</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="ms-3">
              <Button
                variant="contained"
                onClick={() => {
                  setOpenMapView(true);
                }}
                size="medium"
                sx={{ bgcolor: "#4D19D2" }}
                disableElevation
                startIcon={<PinDropOutlinedIcon fontSize="small" />}
              >
                View Map
              </Button>
            </div>

            <Button
              className="ms-2"
              variant="contained"
              disableElevation
              size="medium"
              sx={{ bgcolor: "#4D19D2" }}
              onClick={() => {
                setAgentTarget({
                  open: true,
                });
              }}
            >
              <AddIcon className="me-1" /> SET TARGET
            </Button>
            <Button
              sx={{marginLeft: "20px"}}
              className="ms-2"
              disableElevation
              size="small"
              onClick={() => {
                // downloadExcel();
                setAgentTrackerMessageOpen(true);
              }}
            >
              <DownloadIcon /> Agent Data
            </Button>
          </div>
          <div className="d-flex flex-row align-items-center">
            {!user?.isUserPresenter && <Button
              className="zoom-animation ms-2 me-4"
              variant="outlined"
              sx={{
                fontSize: 10,
                textTransform: "capitalize",
                my: 2,
                cursor: "default",
              }}
              size="small"
              color="secondary"
              onClick={() => {
                navigate(`/cash-receipt-data`, {
                  state: { filter: "agents", date: filter },
                });
              }}
              // disabled={cashRctLoading}
            >
              Money Held By Agents :{" "}
              {cashToBeCollected ? f(cashToBeCollected, "cur") : 0}
            </Button>}
            <Button className="ms-2" color="inherit" onClick={()=>{ setExportDialog(true) }} >
              <FileDownloadIcon/> Export
            </Button>
          </div>
        </div>
        <CustomTableV2
          tableData={tableData}
          tableHeight="80vh"
          columns={columns}
          defaultLimit={50}
          totalCount={totalCount}
          isLoading={isLoading}
          // serialNo={true}
          // stickSL={true}
          page={page}
          limit={limit}
          isPaginated={true}
          allowAll={true}
          pageLoading={isPageLoading}
          onPageChange={handlePageChange}
        />
      </div>

      {/* <CustomCalendar/> */}
      {visitData?.open && (
        <AgentVisitDialog
          open={visitData?.open}
          count={visitData?.visit_count}
          name={visitData?.name}
          visitArray={visitData?.daily_data || []}
          agentData={visitData?.agentData}
          setDistanceByAgent={setDistanceByAgent}
          handleClose={() => {
            setVisitData({
              open: false,
            });
          }}
        />
      )}

      {/* FynoAgentTrackerMessaging*/}
      { 
     <Dialog open={agentTrackerMessageOpen} onClose={() => setAgentTrackerMessageOpen(false)}>
  <DialogTitle>Select Options</DialogTitle>
  <DialogContent>
    <FormControlLabel
      control={
        <Checkbox
          checked={selectedValues.includes("7738319254")}
          onChange={handleChangeFyno}
          name="checkbox1"
          value="9899101094"
        />
      }
      label="Anupam Sir"
    />
    <FormControlLabel
      control={
        <Checkbox
          checked={selectedValues.includes("8860004152")}
          onChange={handleChangeFyno}
          name="checkbox2"
          value="8860004152"
        />
      }
      label="Kshitij Sir"
    />
    <FormControlLabel
      control={
        <Checkbox
          checked={addNew}
          onClick={() => setAddNew((prev) => !prev)}
          name="checkbox4"
          value="New"
        />
      }
      label="New"
    />
    <TextField
      fullWidth
      margin="dense"
      label="Enter Text"
      variant="outlined"
      value={textValue}
      disabled={!addNew}
      onChange={handleTextChangeFyno}
    />

    {/* MUI Date Picker */}
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      <DatePicker
        label="Select Date"
        value={selectedDate}
        format="DD/MM/YYYY"
        onChange={(date) => setSelectedDate(dayjs(date).format("DD/MM/YYYY"))}
        slotProps={{ textField: { fullWidth: true, margin: "dense" } }}
      />
    </LocalizationProvider>
  </DialogContent>
  <DialogActions>
    <Button
      onClick={() => {
        setAgentTrackerMessageOpen(false);
        setTextValue("");
        setAddNew(false);
        setSelectedValues([]);
        setSelectedDate(null);
      }}
    >
      Cancel
    </Button>
    <Button onClick={() => downloadExcel()} variant="contained">
      Submit
    </Button>
  </DialogActions>
</Dialog>
      }

      {agentTarget?.open && (
        <SetTargetModal
          open={agentTarget?.open}
          handleClose={(reload) => {
            setAgentTarget({ open: false });
            if (reload) IntialDataFetch();
          }}
        />
      )}
      {openMapView && (
        <MapView
          open={openMapView}
          handleClose={() => {
            setOpenMapView(false);
          }}
        />
      )}
      {viewTarget?.open && (
        <ViewTargetModal
          viewTarget={viewTarget}
          open={viewTarget?.open}
          handleClose={() => {
            setViewTarget({ ...viewTarget, open: false });
          }}
        />
      )}
      {agentFilesStatusPopup?.open && (
        <ViewAgentFilesStatus
          open={agentFilesStatusPopup.open}
          handleClose={() =>
            setAgentFilesStatusPopup((prev) => ({ ...prev, open: false }))
          }
          agentDetails={agentFilesStatusPopup.agentDetails}
        />
      )}
      <AgentTrackerExports open={exportDialog} handleClose={()=>{setExportDialog(false)}} />
    </>
  );
}

export default AgentTrackerTable;
